module.exports = __webpack_public_path__ + "static/media/dropoff_inactive.d3c86e6d.svg";